import { render, staticRenderFns } from "./CategoriasView.vue?vue&type=template&id=a7e0f53c&scoped=true&"
import script from "./CategoriasView.vue?vue&type=script&lang=ts&"
export * from "./CategoriasView.vue?vue&type=script&lang=ts&"
import style0 from "./CategoriasView.vue?vue&type=style&index=0&id=a7e0f53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e0f53c",
  null
  
)

export default component.exports